import axios from 'axios';

const dev = 'http://localhost:8080/api/';
const prod = '/api/';

const httpEndpoint = process.env.NODE_ENV === 'development' ? dev : prod;

const httpPost = axios.create({
  baseURL: httpEndpoint,
  headers: {
    'Content-type': 'multipart/form-data',
  },
});

const httpStream = axios.create({
  baseURL: httpEndpoint,
  headers: {
    'Content-type': 'application/octet-stream',
  },
});

const httpGet = axios.create({
  baseURL: httpEndpoint,
  timeout: 120000,
  headers: {
    'Content-type': 'application/json',
  },
  responseType: 'blob',
});

const httpJson = axios.create({
  baseURL: httpEndpoint,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const setHeader = (key, value) => {
  httpPost.defaults.headers.common[key] = value;
  httpStream.defaults.headers.common[key] = value;
  httpGet.defaults.headers.common[key] = value;
  httpJson.defaults.headers.common[key] = value;
};

const middlewares = {
  httpEndpoint,
  httpPost,
  httpStream,
  httpGet,
  httpJson,
  setHeader,
};

export default middlewares;
